import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      y: "5.047",
      width: "19.5",
      height: "19.5",
      rx: "4.08673",
      transform: "rotate(-15 0 5.047)",
      class: "faded"
    }, null, -1),
    _createElementVNode("rect", {
      x: "2.5",
      y: "2.5",
      width: "19",
      height: "19",
      rx: "4",
      class: "primary"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6731 8.83703L13.6737 8.83795C14.1218 9.553 13.8443 10.2802 13.3811 10.7699C13.2422 10.9112 13.0663 11.0725 12.8708 11.2354L12.8695 11.2365L12.8152 11.2828C12.4905 11.5595 12.1031 11.8895 11.7952 12.282C11.4659 12.7018 11.2108 13.2131 11.2108 13.8386C11.2108 14.3041 11.5834 14.6917 12.0541 14.6917C12.5247 14.6917 12.8973 14.3041 12.8973 13.8386C12.8973 13.6774 12.9866 13.4854 13.1875 13.2503C13.3853 13.0189 13.6512 12.7907 13.9318 12.5526L13.9379 12.5474C14.1548 12.3633 14.385 12.168 14.5793 11.9702C15.7037 10.825 15.9188 9.24302 15.1014 7.93042C14.4997 6.93876 13.3373 6.375 12.0541 6.375C10.0897 6.375 8.5 8.00204 8.5 9.98873C8.5 10.4542 8.87256 10.8418 9.34324 10.8418C9.81393 10.8418 10.1865 10.4542 10.1865 9.98873C10.1865 8.93306 11.031 8.08115 12.0541 8.08115C12.8068 8.08115 13.393 8.38668 13.6731 8.83703Z",
      class: "contrast"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9861 15.297C11.354 15.297 10.8222 15.8184 10.8222 16.4518V16.4702C10.8222 17.1037 11.354 17.625 11.9861 17.625C12.6183 17.625 13.1501 17.1037 13.1501 16.4702V16.4334C13.1501 15.7913 12.6094 15.297 11.9861 15.297Z",
      class: "contrast"
    }, null, -1)
  ])))
}
export default { render: render }